import styled from 'styled-components';

export const LoadingContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 600px;
`;
